"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRoutingPageTransition_1 = __importDefault(require("../typeAssertions/valueIsRoutingPageTransition"));
const valueIsRoutingTransition_1 = __importDefault(require("../typeAssertions/valueIsRoutingTransition"));
const valueIsRoutingTransitionSpeed_1 = __importDefault(require("../typeAssertions/valueIsRoutingTransitionSpeed"));
const valueIsNotUndefined_1 = __importDefault(require("../typeAssertions/valueIsNotUndefined"));
const appStateSelectBOPageById_1 = __importDefault(require("./appStateSelectBOPageById"));
const buildRoutingFunction = ({ functionName, execute, }) => ({ entryVars: { pageTransition, transition, transitionSpeed }, processor, store, }) => {
    if ((0, valueIsNotUndefined_1.default)(pageTransition) && !(0, valueIsRoutingPageTransition_1.default)(pageTransition)) {
        processor.root.alert(`[${functionName}] Invalid page transition`, `${pageTransition}`);
        return;
    }
    if ((0, valueIsNotUndefined_1.default)(transition) && !(0, valueIsRoutingTransition_1.default)(transition)) {
        processor.root.alert(`[${functionName}] Invalid transition`, `${pageTransition}`);
        return;
    }
    if ((0, valueIsNotUndefined_1.default)(transitionSpeed) && !(0, valueIsRoutingTransitionSpeed_1.default)(transitionSpeed)) {
        processor.root.alert(`[${functionName}] Invalid transition speed`, `${pageTransition}`);
        return;
    }
    const targetPage = (0, appStateSelectBOPageById_1.default)(pageTransition.pageId)(store.getState());
    if ((0, valueIsNotUndefined_1.default)(pageTransition) && !targetPage) {
        processor.root.alert(`[${functionName}] INVALID TARGET PAGE`, pageTransition.pageId);
        return;
    }
    execute({
        store,
        pageId: pageTransition === null || pageTransition === void 0 ? void 0 : pageTransition.pageId,
        transition: {
            type: transition,
            speed: transitionSpeed,
        },
        params: pageTransition === null || pageTransition === void 0 ? void 0 : pageTransition.params,
    });
};
exports.default = buildRoutingFunction;
